import { api } from "../../../http/index";

export default {
    getUsers() {
        return api.get("notifications/users");
    },
    sendNotification(payload) {
        return api.post("notifications/send", payload);
    },
    // WhatsApp methods
    getWhatsappCustomers() {
        return api.get("whatsapp/customers");
    },
    sendWhatsappMessage(payload) {
        return api.post("whatsapp/send", payload);
    },
    checkWhatsappStatus() {
        return api.get("whatsapp/status");
    },
    // Notification Settings methods
    getNotificationSettings() {
        return api.get("notification-settings");
    },
    saveNotificationSettings(payload) {
        return api.post("notification-settings", payload);
    },
    updateCustomerNotifications(customerDoctorId, payload) {
        return api.put(`customer-doctors/${customerDoctorId}/notifications`, payload);
    }
};
